import axios from "axios"

const publicApiUrl  = process.env.REACT_APP_API_URL
const userApiUrl    = process.env.REACT_APP_USER_API_URL;
const adminApiUrl   = process.env.REACT_APP_ADMIN_API_URL;
const lang = localStorage.getItem('i18nextLng')

const axiosPublic = axios.create({
  baseURL: `${publicApiUrl}`,
  headers:{"lang": lang==="en"?"en":"dr"}
});
// TODO: fix the refresh token later.
const token = sessionStorage.getItem('user')
const axiosUser = axios.create({
  baseURL: `${userApiUrl}`,
  headers:{token:token},
  withCredentials: false,
});
const axiosDelete = axios.create({
  baseURL: `${userApiUrl}`,
  headers:{token:token},
  withCredentials: false,
});
const axiosStatic = axios.create({
  baseURL: `${publicApiUrl}`,
});

const adminToken = sessionStorage.getItem("access_token");
const axiosAdmin = axios.create({
  baseURL: adminApiUrl,
  headers: { 'Content-Type': 'application/json', token: adminToken },
});

export { axiosPublic, axiosUser, axiosStatic, axiosAdmin, axiosDelete };